module.exports = __webpack_public_path__ + "static/img/channel.10.60eb335.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channel.10.png
// module id = 221
// module chunks = 138 379 380